import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LuMoreVertical } from "react-icons/lu";
import { toast } from "react-toastify";
import createImg from "../../assets/Vector (6).png";
import AppContext from "../../context/AppContext";
import DeletePermission from "../suspence/DeletePermission";
import {
  deleteProtectedAccounts,
  fetchExportProtected,
} from "../../service/Security";
import translations from "../common/Translations";
import { IoSearch } from "react-icons/io5";
import CommonButton from "../common/CommonButton";
import { CgExport } from "react-icons/cg";

export const SecurityToolbar = ({
  setAccountNo,
  checkedbox,
  selectedRecords,
  setCheckedBox,
  setList,
}) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const {
    setParticularAccount,
    setIsEditRequest,
    workflowId,
    selectedOrgId,
    theme,
    langMode,
    userType,
    projectId
  } = useContext(AppContext);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState("");
  const [deleteItemType, setDeleteItemType] = useState("");
  const [inputValue, setInputValue] = useState(""); // Temporary state for input

  const deleteFunction = async (selectedRecords) => {
    try {
      const data = await deleteProtectedAccounts(selectedRecords);
      if (data.header && data.header.code === 600) {
        setCheckedBox(false);
        setList((prevList) =>
          prevList.filter((item) => !selectedRecords.includes(item.id))
        );
        setIsPopupVisible(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
    handleCloseDeleteModal();
  };

  const navigate = useNavigate();
  const handleCreate = () => {
    if (userType === "super_admin" && !selectedOrgId) {
      toast.warn("Please select an organization before creating an account.");
      return;
    }
    setParticularAccount([]);
    setIsEditRequest(false);
    navigate("/createAccount");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };


  const handleInputChange = (event) => {
    setInputValue(event.target.value); // Update temporary state
  };

  const handleSearch = () => {
    setAccountNo(inputValue); // Set the final value on search
    console.log(inputValue)
  };

  useEffect(() => {
    if (inputValue.length === 0) {
      handleSearch();
    }
  }, [inputValue]);

  const togglePopup = () => {
    setIsPopupVisible((prev) => !prev);
  };

  const showDeleteModal = (type, id) => {
    setDeleteItemType(type);
    setDeleteItemId(id);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const exportReport = async (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      toast.error("Please select both From Date and To Date.");
      return;
    }
    if (!projectId) {
      toast.error("Please select projectId first");
      return;
    }
    try {
      const response = await fetchExportProtected(
        projectId,
        fromDate,
        toDate
      );
      if (response && response.header) {
        const code = response.header.code;
        if (code === 607) {
          toast.error("No Records are Available");
        } else if (code === 600) {
          const s3Link = response.body?.value;
          if (s3Link) {
            try {
              // Fetch the file as a Blob
              const fileResponse = await fetch(s3Link);
              const blob = await fileResponse.blob();

              // Create a download link and trigger the download
              const downloadLink = document.createElement("a");
              const url = window.URL.createObjectURL(blob);
              downloadLink.href = url;
              downloadLink.download = "AccountProtection.xlsx"; // Set the filename
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
              window.URL.revokeObjectURL(url); // Clean up the URL
              toast.success("Excel is downloading");
            } catch (fetchError) {
              console.error("Error downloading file:", fetchError);
              toast.error("Failed to download file");
            }
          } else {
            toast.error("Download link is missing");
          }
        } else {
          toast.error("No records found");
        }
      } else {
        toast.error("Invalid response format");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      toast.error("Failed to fetch report");
    }
  };

  const handleSpecialForm = () => {
    navigate("/special-form");
  };

  return (
    <>
      <div
        className={`bg-white p-2 flex flex-col xsm:gap-y-8 gap-y-2 mb-3 ${theme === "dark"
          ? "dark-mode "
          : theme === "high-contrast"
            ? "high-contrast  "
            : ""
          }`}
      >
        <div
          className={`bg-white flex xl:flex-nowrap lg:flex-nowrap md:flex-nowrap sm:flex-nowrap xsm:flex-nowrap flex-wrap justify-between gap-y-3 items-center mt-3 ${theme === "dark"
            ? "dark-mode  rounded-md "
            : theme === "high-contrast"
              ? "high-contrast  "
              : ""
            }`}
        >
          <div
            className={`text-gray-800 text-sm font-semibold whitespace-nowrap ${theme === "dark"
              ? "dark-mode "
              : theme === "high-contrast"
                ? "high-contrast  "
                : ""
              }`}
          >
            {translations[langMode].name}
          </div>
          <div className="flex flex-nowrap gap-2 items-center">
            <CommonButton onClick={handleCreate} variant="primary" className="whitespace-nowrap xsm:px-4 xsm:py-3 !px-3 !py-2" title={translations[langMode].createproacc}>
              <img src={createImg} alt="create img" />
              <span className="xsm:flex hidden">{translations[langMode].createproacc}</span>
            </CommonButton>

            <CommonButton
              onClick={() => {
                exportReport(fromDate, toDate);
              }}
              className="whitespace-nowrap xsm:px-4 xsm:py-3 !px-3 !py-2"
              variant="success"
              title={translations[langMode].export}
            >
              <span className="xsm:hidden flex">
                <CgExport className="h-5 w-5" />
              </span>
              <span className="xsm:flex hidden">{translations[langMode].export}</span>
            </CommonButton>
          </div>
        </div>
        <div className="flex sm:flex-nowrap flex-wrap justify-start items-end gap-y-4">
          <div className="flex flex-wrap  items-center gap-y-3 order-1 xsm:mr-0 mr-[10px] sm:w-auto w-full xsm:max-w-auto max-w-[83%]">
            <div className="flex xsm:px-2 px-0 mt-3 w-full">
              <div className="relative mt-1 w-full">
                <input
                  id="account-search"
                  autoComplete="new-password" // Alternative to prevent autofill
                  type="text"
                  className={`block h-8 pt-2  text-sm text-gray-900 border border-gray-300  ${langMode === 'ar' ? 'rounded-r-md' : 'rounded-l-md'} sm:w-36 w-full
                   focus:ring-blue-300 focus:border-blue-300  
                    ${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  placeholder={translations[langMode].search}
                  value={inputValue} // Bind temporary state to input
                  onChange={handleInputChange} // Update temporary state on input change
                />
              </div>

              <button
                onClick={handleSearch} // Update state on button click
                className={`h-8 px-4 mt-1 bg-[#236DB4] text-white ${langMode === 'ar' ? 'rounded-l-md' : 'rounded-r-md'}`}
              >
                <IoSearch size={20} />{" "}
              </button>
            </div>
          </div>
          <div className={` ${langMode === 'ar' ? 'gap-3' : ''} flex flex-nowrap gap-2 gap-y-2 space-x-2 sm:me-3 sm:order-2 sm:justify-normal justify-between sm:w-auto w-full order-3 sm:pl-0 pl-2`}>
            <div className="flex flex-col sm:w-auto w-1/2">
              <label
                htmlFor="fromDate"
                className="text-gray-700 text-sm dark:text-gray-300 high-contrast:text-white font-medium"
              >
                {translations[langMode].fromdate}
              </label>
              <input
                id="fromDate"
                type="date"
                className={`form-input text-sm border pt-2 px-3 border-gray-400 rounded-md w-full  h-8 transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${theme === "dark"
                  ? "dark-mode"
                  : theme === "high-contrast"
                    ? "high-contrast bg-black text-white"
                    : ""
                  }`}
                value={fromDate ? formatDate(fromDate) : ""}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!e.target.value) {
                    e.target.type = "text";
                  }
                }}
                onChange={(e) => setFromDate(e.target.value)}
                placeholder={translations[langMode].fromdate}
                aria-label="From Date"
              />
            </div>
            <div className="flex flex-col !ms-0 sm:w-auto w-1/2">
              <label
                htmlFor="toDate"
                className="text-gray-700 text-sm dark:text-gray-300 high-contrast:text-white font-medium"
              >
                {translations[langMode].todate}
              </label>
              <input
                id="toDate"
                type="date"
                className={`form-input border text-sm pt-2 px-3 border-gray-400 rounded-md w-full h-8 transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${theme === "dark"
                  ? 'dark-mode'
                  : theme === "high-contrast"
                    ? "high-contrast bg-black text-white"
                    : ""
                  }`}
                value={toDate ? formatDate(toDate) : ""}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!e.target.value) {
                    e.target.type = "text";
                  }
                }}
                onChange={(e) => setToDate(e.target.value)}
                placeholder={translations[langMode].todate}
                aria-label="To Date"
              />
            </div>
          </div>
          <div className="ml-auto flex items-center p-2 px-2 rounded-md border-2 border-gray-400 bg-white h-8 text-sm sm:order-3 order-2">
            <LuMoreVertical
              className={`text-md ${checkedbox
                ? "cursor-pointer text-black"
                : "cursor-not-allowed text-gray-400"
                }`}
              onClick={checkedbox ? togglePopup : null}
            />
            {isPopupVisible && (
              <div className={`absolute ${langMode === 'ar' ? 'left-20 mt-2' : 'right-14 mt-5'}   w-32 bg-white border border-gray-300 rounded-lg shadow-lg`}>
                <button
                  type="button"
                  className="w-full px-4 py-2 text-left text-red-600 hover:bg-red-100 rounded-t-lg"
                  onClick={() => showDeleteModal("single", null)}
                >
                  {translations[langMode].delete}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {deleteModalOpen && deleteItemType === "single" && (
        <DeletePermission
          deleteFunction={() => deleteFunction(selectedRecords)}
          onClose={handleCloseDeleteModal}
          onDeleteText="Are you sure you want to delete record?"
        />
      )}
    </>
  );
};
